import type { CommonNodeViewWrapperProps } from '@/components/common/node-view-wrapper';
import { useCollaborationNodePresence } from '@/hooks/use-collaboration-node-presence';
import type { CollaborationPresenceUser } from '@/hooks/use-collaboration-presence';
import type { Editor } from '@tiptap/react';
import { useMemo } from 'react';

export type NodeViewCollaborationPresenceProps = {
    presenceUsers: CollaborationPresenceUser[];
    presenceTracking: NonNullable<CommonNodeViewWrapperProps['presenceTracking']>;
};

export function useNodeViewCollaborationPresence(
    editor: Editor,
    nodeId: unknown,
    nodeType: string,
    isActive: boolean,
): NodeViewCollaborationPresenceProps {
    const collabProvider = editor.storage.collaborationNodePresence?.provider ?? null;
    const normalizedNodeId = typeof nodeId === 'string' ? nodeId : null;
    const presenceUsers = useCollaborationNodePresence(collabProvider, normalizedNodeId);

    const presenceTracking = useMemo(
        () => ({
            collabProvider,
            nodeId: normalizedNodeId,
            nodeType,
            isActive,
        }),
        [collabProvider, normalizedNodeId, nodeType, isActive],
    );

    return { presenceUsers, presenceTracking };
}
